/* eslint-env es2020 */
/* global globalThis */

(function () {
  if (typeof URL === "undefined") return;
  if (typeof URL.canParse === "function") return;
  const globalRef =
    typeof globalThis !== "undefined"
      ? globalThis
      : typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : {};
  const getBaseHref = () => {
    try {
      if (typeof document !== "undefined" && document.baseURI) {
        return document.baseURI;
      }
      if (globalRef && globalRef.location && globalRef.location.href) {
        return globalRef.location.href;
      }
    } catch (e) {}
    return undefined;
  };
  const baseHref = getBaseHref();
  const canParseImpl = function (input) {
    if (typeof input !== "string" || input.trim() === "") return false;
    try {
      new URL(input, baseHref);
      return true;
    } catch (e) {
      return false;
    }
  };
  Object.defineProperty(URL, "canParse", {
    value: canParseImpl,
    writable: false,
    configurable: true,
  });
})();
